import './applied_labels_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostLabelsView extends Monitoring.Views.SocialContents.Filters.AppliedLabelsView
  name: 'post_labels'

  removeFilter: (value) ->
    @searchQuery.removePostLabel(value)


  # Fix hasta que el filtro de labels de modo campaign sea como el de modo explore

  withPrefix: (search_query_field) ->
    "post_#{search_query_field}"

  _primaryName: () ->
    'labels'
